import { ArrowUpRightIcon as PhosphorArrowUpRightIcon } from "@phosphor-icons/react/dist/ssr/ArrowUpRight";

import { createAppIcon } from "@/components/createAppIcon";

export const ExternalArrowIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowUpRightIcon);
